export default "__VITE_PUBLIC_ASSET__a6c6238f__"